import { render, staticRenderFns } from "./editTestResult.vue?vue&type=template&id=add711f8&"
import script from "./editTestResult.vue?vue&type=script&lang=js&"
export * from "./editTestResult.vue?vue&type=script&lang=js&"
import style0 from "./editTestResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports